import { render, staticRenderFns } from "./MemoListItem.vue?vue&type=template&id=6b974a7a&lang=pug&"
import script from "./MemoListItem.vue?vue&type=script&lang=js&"
export * from "./MemoListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemoListItem.vue"
export default component.exports